"use strict";

exports.__esModule = true;
exports.HelpPanel = void 0;
var _react = _interopRequireWildcard(require("react"));
var _icons = require("@blueprintjs/icons");
var _Panel = require("../Core/Panel");
var _HelpContext = require("./HelpContext");
var _excluded = ["help"];
var _dec, _class, _HelpPanel;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Displays a help topic in a panel.
 */
var HelpPanel = exports.HelpPanel = (_dec = _HelpContext.HelpContext.withContext, _dec(_class = (_HelpPanel = /*#__PURE__*/function (_Component) {
  function HelpPanel() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.handleClose = function () {
      var help = _this.props.help;
      help.unsetTopic();
    };
    return _this;
  }
  _inheritsLoose(HelpPanel, _Component);
  var _proto = HelpPanel.prototype;
  _proto.render = function render() {
    // eslint-disable-next-line no-unused-vars
    var _this$props = this.props,
      help = _this$props.help,
      extra = _objectWithoutPropertiesLoose(_this$props, _excluded);
    var topic = help.currentTopic;
    if (!topic) {
      return null;
    }
    return /*#__PURE__*/_react["default"].createElement(_Panel.Panel, {
      icon: _icons.IconNames.HELP,
      title: topic.title,
      onClose: this.handleClose
    }, topic.render());
  };
  return HelpPanel;
}(_react.Component), _HelpPanel.defaultProps = {
  help: undefined
}, _HelpPanel)) || _class);